import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import { NucleoModel } from '../../models/vmi-nucleoModel';

@Injectable({
  providedIn: 'root'
})
export class VmiPenetracionService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.informes;
  }

  getPenetracionFiltrado(idCliente: string, idArticulo: string, desde: string, hasta: string): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionFiltrado + `/${idCliente}/${idArticulo}/${desde}/${hasta}`);
  }

  getPenetracionFiltradoLegado(idCliente: string, idArticulo: string, desde: string, hasta: string): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionFiltradoLegacy + `/${idCliente}/${idArticulo}/${desde}/${hasta}`);
  }

  getPenetracionCrudo(idCliente: string, idArticulo: string, desde: string, hasta: string): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionRaw + `/${idCliente}/${idArticulo}/${desde}/${hasta}`);
  }

  getPenetracionCrudoLegado(idCliente: string, idArticulo: string, desde: string, hasta: string): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionRawLegacy + `/${idCliente}/${idArticulo}/${desde}/${hasta}`);
  }

  getPenetracionFiltradoImagen(idCliente: string, idArticulo: string, desde: string, hasta: string): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionFiltrado + `/foto/${idCliente}/${idArticulo}/${desde}/${hasta}`);
  }

  getPenetracionFiltradoImagenLegado(idCliente: string, idArticulo: string, desde: string, hasta: string): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionFiltradoLegacy + `/foto/${idCliente}/${idArticulo}/${desde}/${hasta}`);
  }

  getPenetracionFiltradoPdf(idCliente: string, idArticulo: string, hasta: string){
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionFiltradoPdf + `/${idCliente}/${idArticulo}/${hasta}`)
  }

  getPenetracionFiltradoSegumiento(desde: string, hasta: string, codigo: string){
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionSegumiento + `/${desde}/${hasta}/${codigo}`)
  }

  getPenetracionFiltradoSegumientoRaw(codigo: string){
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.penetracionSegumientoRaw + `/${codigo}`)
  }


}
